module.exports = __webpack_public_path__ + "static/img/under_construction_1.83483844.svg";